import "core-js/modules/es7.array.includes";
import "core-js/modules/web.dom.iterable";
import { getAuthStorage } from '@/api/service-localstorage';
import http from "../api/http";
var ecapi = process.env.VUE_APP_EC_API;
var common = {
  methods: {
    // 获取最优视野zoom值
    _getOptimalZoom: function _getOptimalZoom(latlng, attentionViVews) {
      if (L.isEmpty(attentionViVews)) {
        return undefined;
      }

      var views = attentionViVews;
      var zoom;
      views.forEach(function (view) {
        if (L.latLngBounds(view.bounds).contains(latlng)) {
          zoom = view.zoom;
          return false;
        }
      });
      return zoom;
    },
    // 设置台风中心视野
    _mapSetView: function _mapSetView(center, zoom) {
      try {
        var map = this.$map;
        map.setView(center, zoom);
      } catch (e) {
        throw new Error('zomm or center not found');
      }
    },
    addBaiduTrackEvent: function addBaiduTrackEvent(param) {
      var _window = window,
          _hmt = _window._hmt;
      if (!_hmt) return; // 没配置先废弃
      //   获取当前的用户账号

      var userName = window.GLOBAL_CONFIG.projectId; // 设置排除的账号 有可能发生类型不符的情况

      var exclude = [2, 14, 72, 76, 62, 61, 60];
      if (exclude.includes(+userName)) return; // console.log('追踪执行成功') // 测试使用

      _hmt.push(param);
    },
    // 设置访问量统计，主要是用四创自己统计
    addIstrongTrackEvent: function addIstrongTrackEvent(params) {
      if (!window.GLOBAL_CONFIG) return; // 账号信息没在直接拦截

      var _window2 = window,
          GLOBAL_CONFIG = _window2.GLOBAL_CONFIG,
          navigator = _window2.navigator,
          screen = _window2.screen;
      var projectId = GLOBAL_CONFIG.projectId;

      var _getAuthStorage = getAuthStorage('auth'),
          accesstoken = _getAuthStorage.accesstoken;

      var userAgent = navigator.userAgent;
      var pixels = "".concat(screen.width, "*").concat(screen.height); // 分辨率

      var url = "".concat(ecapi, "/api/zzh/v2/operationlog");
      http.post(url, {
        MCode: params,
        LoginAccount: accesstoken,
        Browser: userAgent,
        ResolvingPower: pixels,
        CompanyId: +projectId,
        Equipment: ''
      });
    },
    // 判断全局是否需要展示概率圈
    renderIshowProbability: function renderIshowProbability(tfbh) {
      var _window$GLOBAL_CONFIG = window.GLOBAL_CONFIG.typhoonProperties,
          typhoonProperties = _window$GLOBAL_CONFIG === void 0 ? {} : _window$GLOBAL_CONFIG;
      var _typhoonProperties$di = typhoonProperties.dispalyProbability,
          dispalyProbability = _typhoonProperties$di === void 0 ? [] : _typhoonProperties$di;
      return dispalyProbability.indexOf(tfbh) !== -1;
    }
  }
};
export default common;